var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basketball_halfFeild_shootHotspot"},[_c('div',{ref:"echartDom_home",staticClass:"echart_dom",style:({ height: `${_vm.pHeight}px` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }